import { observer } from "mobx-react-lite";
import { ReactElement } from "react";
import { Box, Center, Flex, Spinner } from "@chakra-ui/react";

import { useIsReady } from "@noli/business";

import { LEFT_WIDTHS } from "@/utils/constants";
import { themeStore } from "@/stores/theme";
import { LeftPanelType, uiStore } from "@/stores/ui";
import LeftNavigation from "./LeftNavigations";
import { Txt2ImgPanel } from "./Txt2ImgPanel";
import PresetsPanel from "./PresetsPanel";
import SettingsPanel from "./SettingsPanel";
import ImageProcess from "./ImageProcess";
import LocalErase from "./LocalErase";
import LocalReplace from "./LocalReplace";
import { genBlock } from "@/utils/bem";
import { Txt2ImgVariation } from "./Txt2ImgVariation";
import { Params2Img } from "./Params2Img";
import { NegativePromptPanel } from "./NegativePrompt";
import { Img2ImgPanel } from "./Img2Img";
import { OutpaintingPanel } from "./Outpainting";
import { useScrollBar } from "@/hooks/useScrollbar";
import { MattPanel } from "./MattPanel";

const LeftPanelMapping: Record<Partial<LeftPanelType>, ReactElement> = {
  txt2img: <Txt2ImgPanel />,
  txt2imgVariation: <Txt2ImgVariation />,
  img2img: <Img2ImgPanel />,
  imageProcess: <ImageProcess />,
  inpainting: <LocalErase />,
  "text2img-inpainting": <LocalReplace />,
  negativePrompt: <NegativePromptPanel />,
  outpainting: <OutpaintingPanel />,
  txt2imgPresets: <PresetsPanel />,
  params2img: <Params2Img />,
  settings: <SettingsPanel />,
  matt: <MattPanel />,
};

const block = genBlock("c-left-panel");
function LeftPanel() {
  const { panelBg, separatorColor } = themeStore.styles;
  const { scrollBarProps } = useScrollBar({
    containerSelector: `.${block({ e: "content " })}`,
  });
  console.log("scrollBarProps: ", scrollBarProps);

  if (!useIsReady()) {
    return (
      <Box w={LEFT_WIDTHS} h="100%" bg={panelBg}>
        <Center pt="100px">
          <Spinner color="gray.400" size="md" />
        </Center>
      </Box>
    );
  }

  return (
    <Flex
      className={block()}
      w={LEFT_WIDTHS}
      h="100%"
      bg={panelBg}
      direction="column"
      userSelect="none"
    >
      <Flex w="100%" flex={1} overflow="hidden">
        <Box flexShrink={0} w="64px" h="100%" borderRight="1px" borderColor={separatorColor}>
          <LeftNavigation />
        </Box>
        <Box className={block({ e: "content" })} flex={1} height="100%" {...scrollBarProps}>
          {LeftPanelMapping[uiStore.leftPanel]}
        </Box>
      </Flex>
    </Flex>
  );
}

export default observer(LeftPanel);
